<template>
    <div class="mobile-menu"
         :style="{'margin-top': `${heightInfoBar}px`}">
        <v-window v-model="activeSlide">
            <v-window-item>
                <v-list class="pa-0" :elevation="0">
                    <v-list-item
                        v-for="(item) in menu"
                        :key="item.id"
                        :id="`activator-${item.id}`"
                        :href="item.url"
                        :active="props.menuModel?.includes(item.id)"
                        @click.prevent="mainClick(item)"
                        :prepend-avatar="item.main_image.url"
                        :append-icon="null"
                        class="c-menu-item"
                        color="orange">
                        <v-list-item-title>
                            <div class="list-name font-weight-bold text-black">{{ item.name }}</div>
                        </v-list-item-title>
                        <template v-slot:prepend>
                            <v-img :src="item.main_image.url" class="mr-2 ml-n1" :width="24"
                                   :class="activeMenu[item.id]?'colored':'grayscale'"></v-img>
                        </template>
                        <template v-slot:append>
                            <v-icon :icon="mdiChevronRight" v-if="item.children.length > 0"></v-icon>
                        </template>
                    </v-list-item>
                    <v-list-item
                        v-if="newsGroup.id"
                        :href="newsGroup.url"
                        :active="props.menuModel?.includes(newsGroup.id)"
                        @click.prevent="go(newsGroup.url)"
                        class="c-menu-item"
                        color="orange">
                        <v-list-item-title>
                            <div class="font-weight-light">{{ newsGroup.name }}</div>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        v-if="actionGroup.id"
                        :href="actionGroup.url"
                        :active="props.menuModel?.includes(actionGroup.id)"
                        @click.prevent="go(actionGroup.url)"
                        class="c-menu-item"
                        color="orange">
                        <v-list-item-title>
                            <div class="font-weight-light">{{ actionGroup.name }}</div>
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-container class="bg-grey-lighten-4 list-border ">
                    <v-row class="ma-n7">
                        <v-col cols="auto">
                            <v-list
                                class="bg-transparent">
                                <v-list-item
                                    @click.prevent.capture="go(route('eshop.cartImport'))"
                                    color="orange">
                                    <v-list-item-title>
                                        <div class="list-name font-weight-bold text-black">
                                            {{ $t('app-bar.product_import') }}
                                        </div>
                                    </v-list-item-title>
                                    <template v-slot:prepend>
                                        <v-icon :icon="mdiCloudUploadOutline" class="mr-n6"></v-icon>
                                    </template>
                                </v-list-item>
                                <v-list-item
                                    @click.prevent="go(route('customer.shopping-lists'))"
                                    color="orange">
                                    <v-list-item-title>
                                        <div class="list-name font-weight-bold text-black">
                                            {{ $t('app-bar.saved_products') }}
                                        </div>
                                    </v-list-item-title>
                                    <template v-slot:prepend>
                                        <v-icon :icon="mdiContentSaveOutline" class="mr-n6"></v-icon>
                                    </template>
                                </v-list-item>
                                <!--                            TODO: až bude úkol u25196-->
                                <v-list-item
                                    href="/"
                                    v-if="false"
                                    color="orange">
                                    <v-list-item-title>
                                        <div class="list-name font-weight-bold text-black">
                                            {{ $t('app-bar.my_garage') }}
                                        </div>
                                    </v-list-item-title>
                                    <template v-slot:prepend>
                                        <v-badge left color="green" :content="4">
                                            <v-icon :icon="mdiHomeOutline" class="mr-n6"></v-icon>
                                        </v-badge>
                                    </template>
                                </v-list-item>
                            </v-list>
                        </v-col>
                        <v-col>
                            <div class="links-wrapper">
                                <div v-for="(link, i) in links" :key="i" class="clickable-link">
                                    <div class="text-tiny-link cursor-pointer" @click="go(link.link)">{{ link.title }}</div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container>
                    <v-row class="pt-4">
                        <v-col cols="auto" class="pa-0">
                            <v-icon :icon="mdiPhoneOutline" size="20" class="ml-3 mr-2" color="grey-lighten-1"></v-icon>
                        </v-col>
                        <v-col cols="auto" class="pa-0">
                            <p class="text-tiny-link font-weight-bold mr-2">
                                {{ $t('app-bar.customer_service_phone') }}</p>
                            <p class="text-tiny-link text-grey">{{ $t('app-bar.customer_service_hours') }}</p>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="pa-0 pr-4" cols="auto">
                            <v-btn v-if="$page.props.customer && $page.props.customer.is_dealer" variant="text" :prepend-icon="priceHider?.pricesHidden ? mdiEyeOutline : mdiEyeOffOutline"
                                   @click="() => {
                                       priceHider.togglePrices()
                                       emit('close')
                                   }" density="compact" class="mr-n4 text-body-2 font-weight-light">
                                <span v-if="!priceHider?.pricesHidden">{{ $t('app-bar.hide_prices') }}</span>
                                <span v-else>{{ $t('app-bar.show_prices') }}</span>
                            </v-btn>
                            <!-- TODO: tady dokončit až bude výběrovník na měny -->
                        </v-col>
                    </v-row>
                </v-container>
            </v-window-item>
            <v-window-item v-for="(slide, s) in menuSlides" :key="s">
                <v-list class="pa-0">
                    <v-list-item
                        @click.prevent="goBack"
                        class="c-menu-item bg-orange-lighten-4"
                        color="orange">
                        <v-list-item-title>
                            <div class="text-body-3 font-weight-bold text-wrap" v-if="slide">{{ slide.name }}</div>
                        </v-list-item-title>
                        <template v-slot:append>
                            <div @click="go(slide.url)" class="text-orange text-decoration-underline text-tiny-link">
                                {{ $t('app-bar.show_all') }}
                            </div>
                        </template>
                        <template v-slot:prepend>
                            <v-icon :icon="mdiChevronLeft" color="grey-darken-4" class="ml-n2 mr-n7"></v-icon>
                        </template>
                    </v-list-item>
                    <v-list-item
                        v-if="slide"
                        v-for="(item) in slide.children"
                        :key="item.id"
                        :id="`activator-${item.id}`"
                        :href="item.url"

                        :active="props.menuModel?.includes(item.id)"
                        @click.prevent="mainClick(item)"
                        :prepend-avatar="item.main_image.url"
                        :append-icon="null"
                        class="c-menu-item"
                        color="orange">
                        <v-list-item-title>
                            <div class="list-name font-weight-bold text-black text-wrap">{{ item.name }}</div>
                        </v-list-item-title>
                        <template v-slot:prepend>
                            <v-img :src="item.main_image.url" class="mr-2 ml-n1" :width="24"></v-img>
                        </template>
                        <template v-slot:append>
                            <v-icon :icon="mdiChevronRight" v-if="item.children.length > 0"></v-icon>
                        </template>
                    </v-list-item>
                </v-list>
            </v-window-item>
        </v-window>
    </div>
</template>
<script setup>
import {
    mdiChevronLeft,
    mdiChevronRight,
    mdiCloudUploadOutline,
    mdiContentSaveOutline, mdiEyeOffOutline, mdiEyeOutline, mdiHomeOutline, mdiPhoneOutline,
} from '@mdi/js';
import { ref, toRaw, watch, inject, computed } from 'vue';
import {router, usePage} from '@inertiajs/vue3';
import { useDisplay } from 'vuetify';
import { trans } from 'laravel-vue-i18n';
import priceHiderStore from "../../../../../Modules/Eshop/Resources/js/composables/priceHiderStore.js";
import pinia from '../../../plugins/pinia.js';

const emit = defineEmits(['close']);
const props = defineProps({
    menu: Array,
    menuModel: Array,
    activeMenu: Object,
    heightInfoBar: Object,
});
const activeSlide = ref(0);
const menuSlides = ref([{}]);
const priceHider = priceHiderStore(pinia);
const menu = computed(() => {
    return props.menu.filter((item) => {
        return !item.action && !item.news;
    });
});

const actionGroup = computed(() => {
    return props.menu.filter((item) => {
        return item.action;
    }).pop();
});

const newsGroup = computed(() => {
    return props.menu.filter((item) => {
        return item.news;
    }).pop();
});
const goBack = () => {
    activeSlide.value--;
};
const route = inject('route');
const { lgAndUp } = useDisplay();

watch(lgAndUp, (now) => {
    if (now)
        emit('close');
});

const mainClick = (item) => {
    if (item.children.length > 0) {
        menuSlides.value[activeSlide.value] = item;
        menuSlides.value[activeSlide.value + 1] = {};
        activeSlide.value++;
    } else
        go(item.url);
};

const go = (where) => {
    router.visit(where);
    emit('close');
};


const links = computed(() => Object.values(usePage().props.menu.topMenu)?.sort((a,b) => a.sort - b.sort).map(el => {
    return {
        link: el.url,
        title: el.title,
    }
}));

const menuModel = ref(structuredClone(toRaw(props.menuModel)));
</script>
<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'sass:map';
// TODO: dořešit jak to pak bude s proužkem, možná bude potřeba předělat to odsazení

$marginFromTop: 46.5px;
$marginFromMdTop: 63.5px;

.grayscale {
    filter: invert(65%) sepia(58%) saturate(0%) hue-rotate(283deg) brightness(81%) contrast(92%);
}

.colored {
    filter: invert(73%) sepia(46%) saturate(5792%) hue-rotate(347deg) brightness(98%) contrast(89%);
}

.mobile-menu {
    width: 100%;
    height: calc(100vh - $marginFromTop);
    top: $marginFromTop;
    background-color: white;
    position: fixed;
    z-index: 1005;
    @media #{map.get($display-breakpoints, 'md-and-up')} {
        height: calc(100vh - $marginFromMdTop);
        top: $marginFromMdTop;
    }

    .list-border {
        border: 1px solid map.get($grey, 'lighten-2');
        border-left: none;
        border-right: none;
    }

    .c-menu-item {
        border-top: 1px solid map.get($grey, 'lighten-2');
    }

    .links-wrapper {
        display: flex;
        flex-direction: column;
        gap: 12px;
        border-left: 1px solid map.get($grey, 'lighten-2');
        padding: 16px;
    }

    .align-items-center {
        align-items: center;
    }

    .v-window-item {
        width: 100vw;
        height: calc(100vh - $marginFromTop);
        -ms-overflow-style: none;
        scrollbar-width: none;
        overflow: scroll;
        @media #{map.get($display-breakpoints, 'md-and-up')} {
            height: calc(100vh - $marginFromMdTop);
        }
        &::-webkit-scrollbar {
            display: none;
        }
    }
}
</style>
